import * as prismicH from '@prismicio/helpers';
import { PrismicRichText } from '@prismicio/react';
import Subscribe from '../../components/Subscribe';
import { Heading } from '../../components/Heading';
import { SocialIcons } from '../../components/SocialIcons';
import PrismicLink from '../../components/PrismicLink';

/**
 * @typedef {import("@prismicio/client").Content.CallToActionSlice} CallToActionSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<CallToActionSlice>} CallToActionProps
 * @type {import("react").FC<CallToActionProps>}
 */
const CallToAction = ({ slice }) => {
  const bgClass = slice.primary.backgroundColour
    ? `text-bg-${slice.primary.backgroundColour}`
    : '';
  if (slice.variation === 'twoColumns') {
    return (
      <div className={`border-bottom py-6 ${bgClass}`}>
        <div className="container">
          <div className="row gx-lg-6 gy-5">
            <CTABlock
              className="col-lg-6"
              headingTag="h4"
              description={slice.primary.description}
              button={slice.primary.button}
            />
            <CTABlock
              className="col-lg-6"
              headingTag="h4"
              description={slice.primary.description2}
              button={slice.primary.button2}
            />
          </div>
        </div>
      </div>
    );
  } else if (isSliceFilled(slice, true)) {
    return (
      <div className={`border-bottom py-6 ${bgClass}`}>
        <div className="container">
          <div className="row py-5">
            <CTABlock
              className="col-lg-8 mx-auto text-center"
              headingTag="h2"
              description={slice.primary.description}
              button={slice.primary.button}
              showSocialIcons={slice.primary.showSocialIcons}
              mailchimpAudienceId={slice.primary.mailchimpAudienceId}
            />
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

function CTABlock({
  description,
  button,
  showSocialIcons,
  mailchimpAudienceId,
  headingTag,
  ...props
}) {
  return (
    <div {...props}>
      <PrismicRichText
        field={description}
        components={{
          heading2: ({ children }) => (
            <Heading as={headingTag} className="mb-2">
              {children}
            </Heading>
          )
        }}
      />
      <div className="mt-4">
        {mailchimpAudienceId && (
          <div className="d-flex justify-content-center mb-4">
            <Subscribe id={mailchimpAudienceId} />
          </div>
        )}
        {prismicH.isFilled.link(button) && (
          <PrismicLink field={button} className="btn btn-primary px-4" />
        )}
        {showSocialIcons && <SocialIcons />}
      </div>
    </div>
  );
}

function isSliceFilled(slice, full) {
  const isFilledBasic =
    prismicH.isFilled.link(slice.primary.button) ||
    prismicH.isFilled.richText(slice.primary.description);
  if (!full) {
    return isFilledBasic;
  } else {
    return (
      isFilledBasic ||
      slice.primary.mailchimpAudienceId ||
      slice.primary.showSocialIcons
    );
  }
}

export default CallToAction;
